module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-800italic.woff2?b5bc26612cdf4d47affd6988bcdc8c0f";